<template>
  <div id="app">
    <section id="main_proposition" class="home">
      <div class="home-decor">
        <div class="home-circle1"><img :src='"../../assets/images/main-banner3-blue.png"' alt=""></div>
        <div class="home-circle2"><img :src='"../../assets/images/main-banner12-blue.png"' alt=""></div>
        <div class="home-circle3"><img :src='"../../assets/images/main-banner1-blue.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <div class="home-contain">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    <carousel :className='"blog-carousel"'
                              :loop=true
                              :margin=30
                              :items=1
                              :center=false
                              :nav=false
                              :dots=true
                              :autoplay=true
                              :autoplayTimeout=12000
                              :responsive="{0:{items:1,nav:false}}">
                      <div class="blog-item" v-for="i in [1,2,3]" :key="i">
                        <div class="blog-text">
                          <h3>{{ $t(`offer.main.text${i}.text`) }}
                          </h3>
                          <h5>{{ $t(`offer.main.text${i}.underText`) }}</h5>
                        </div>
                      </div>
                    </carousel>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-6 offset-xl-1 sm-d-none">
            <div class="home-contain fadeIn-mac">
              <!-- Tile js start -->
              <Tile :max="30" :image='"mediamodifier_image_3.png"'/>
              <!-- Tile js end -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'MainOffer'
  }
</script>




// WEBPACK FOOTER //
// src/components/offerPage/main_offer.vue